import { call, select, takeLatest } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { sendEventDataEmailCall } from "../../apis/wpApi/apiCalls"
import authUser from "../../apis/wpApi/authUser"
import { checkResponse, putError, putSuccess } from "../helpers"
import { EVENT_DATA } from "../../constants/state"
import { overlaySetRequestType } from "../programSaga/helpers/request"


const selectItem = (state, id) => state.getIn([EVENT_DATA, 'events', 'data', 'items', String(id)])

function* sendEventEmail(payload) {
    try {
        yield overlaySetRequestType(actionTypes.EVENTS_EVENTS_SEND_MAIL_REQUEST)

        const { id } = yield payload.payload

        if(!id) {
            throw new Error('No id')
        }
       
        const apiKey = yield call(authUser.getToken)
        const item =   yield select(selectItem, id)

        if(!item) { //ToDo: testen
            throw new Error('No event to update found')
        }

        const response = yield call(sendEventDataEmailCall, apiKey, item)
        
        yield call(checkResponse, response)
        yield call(putSuccess, actionTypes.EVENTS_EVENTS_SEND_MAIL_SUCCESS, { data: response.data})
    } catch(e) {
        yield call(putError, actionTypes.EVENTS_EVENTS_UPDATE_ERROR, e.message)
    }
}


function* watchEventSendMailRequest() {
    try {
        yield takeLatest(actionTypes.EVENTS_EVENTS_SEND_MAIL_REQUEST, sendEventEmail)
    } catch(e) {
        console.log('error!!!!!', e.message)
    }
}


export default watchEventSendMailRequest;